export const LogoMark = ({ size = 34, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className} aria-label="Beyond the Pain logo">
    <circle cx="24" cy="24" r="22.5" stroke="#5E7D6A" strokeWidth="1.4" />
    <path
      d="M24 34c-5.2 0-9-3.6-9-8.4 0-4.4 3.4-7.6 9-12.4 5.6 4.8 9 8 9 12.4 0 4.8-3.8 8.4-9 8.4Z"
      stroke="#5E7D6A"
      strokeWidth="1.4"
      fill="#F4E3E0"
    />
    <path d="M24 34V20" stroke="#5E7D6A" strokeWidth="1.2" />
    <path d="M24 26c-2-1.4-3.4-3-4-5.2M24 26c2-1.4 3.4-3 4-5.2" stroke="#5E7D6A" strokeWidth="1.1" />
  </svg>
);
